import './ObjectPermissionsTag.scss';
import classNames from 'classnames';
import { ObjectPermission } from '@sonar-software/sonar-core';
import React from 'react';
import { Col, Space, Tooltip } from 'antd';
export const permissionLabel = {
    [ObjectPermission.create]: 'C',
    [ObjectPermission.read]: 'R',
    [ObjectPermission.edit]: 'E',
    [ObjectPermission.delete]: 'D',
    [ObjectPermission.viewAllData]: 'V',
    [ObjectPermission.modifyAllData]: 'M'
};
export const ObjectPermissionsTag = ({ permissions }) => React.createElement(Space, { className: 'object-permissions-tags', size: 4 }, Object.entries(permissionLabel).map(([key]) => {
    var _a;
    return React.createElement(Col, { className: classNames('permission-tag', {
            hasLabel: permissions[key] !== undefined && permissions[key] !== '',
            hasPermission: permissions[key] !== undefined
        }), key: key },
        React.createElement(Tooltip, { title: (_a = permissions[key]) !== null && _a !== void 0 ? _a : '' }, permissionLabel[key]));
}));
